import React, { useState } from 'react';
import { ImageList, ImageLink, NameLink, NameList, ImageEntry, NameEntry } from './styles.Authors';
import { Author } from '../../../config/models';
import { mainConfig } from '../../../config/config.provider';
import { AuthorMap } from '../../../config/authorsMap';

interface TagProps {
    elements?: Author[];
    isDark?: boolean;
}

const fallbackAuthorImg = 'https://img.br.de/0dac46ea-dcb0-413b-9b1e-44a44bbf6524.png?q=100';
const fallbackAuthorLink = 'https://www.br.de/nachrichten/autoren/br24-redaktion,18ebe837-9062-482c-9217-50ce772a3377';

export const Authors: React.FC<TagProps> = ({ children, elements, isDark }) => {
    const [activeAuthor, setActiveAuthor] = useState<string | undefined>();

    const activeness = (author: string) => ({
        isActive: activeAuthor === author,
        onMouseOver: () => setActiveAuthor(author),
        onMouseLeave: () => setActiveAuthor(undefined)
    });

    const authors = elements || mainConfig.authors;

    return (
        <>
            <ImageList>
                {authors.map((author, index) => (
                    <ImageEntry key={`authorImage-${index}`}>
                        <ImageLink
                            href={AuthorMap[author].link || fallbackAuthorLink}
                            target="_blank"
                            index={index}
                            {...activeness(author)}
                            img={AuthorMap[author].img || fallbackAuthorImg}
                        />
                    </ImageEntry>
                ))}
            </ImageList>
            <NameList>
                {authors.map((author, index) => (
                    <NameEntry key={`authorName-${index}`}>
                        <NameLink
                            href={AuthorMap[author].link || fallbackAuthorLink}
                            target={AuthorMap[author].link === '#' ? '' : '_blank'}
                            isDark={isDark}
                            {...activeness(author)}
                        >
                            {author}
                        </NameLink>
                    </NameEntry>
                ))}
            </NameList>
        </>
    );
};
